module.exports = __webpack_public_path__ + "static/img/图层 43.b469112c.png";